<div class="mobile-dialog desktop-dialog">
  <div class="col-12 head-dialog d-flex justify-content-between align-items-center">
    <span>{{ 'RegisterAComment' | translate }}</span>
    <img (click)="noAction()"
         class="cursor-pointer"
         src="/icons/close-circle.svg">
  </div>
  <div class="parent-comment d-flex flex-column align-items-center">
    <span>{{ 'HowDoYouRateYourOrder' | translate }}</span>
    <app-frontend-star-rate [(userRate)]="rating"></app-frontend-star-rate>
    <app-frontend-text-area [(value)]="comment"
                            class="textArea-style w-100"></app-frontend-text-area>
    <div class="col-12 d-flex justify-content-center align-items-center res-btn">
      <app-frontend-button (click)="onSubmitClicked()"
                           [title]="'Submit'"
                           class="shadow w-100"></app-frontend-button>
    </div>
  </div>
</div>
